import React from 'react';
import RootContainer from './components/containers/root_container';
import { HashRouter } from "react-router-dom";
import './App.scss';

function App() {
  return (
    <HashRouter>
      <RootContainer />
    </HashRouter>
  );
}

export default App;
